var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 30.024v451.952h512v-451.952zm482 30v90.096h-452v-90.096zm-452 391.952v-271.856h452v271.856z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.036 90.072h30.024v30h-30.024z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m120.084 90.072h30.024v30h-30.024z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m180.132 90.072h30.024v30h-30.024z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m210.976 391.096h90.048v-150.096h-90.048zm30-120.096h30.048v90.096h-30.048z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m150.928 301.048h-30.048v-60.06h-30v90.06h60.048v60.06h30v-150.12h-30z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m391.12 301.048h-30.048v-60.06h-30v90.06h60.048v60.06h30v-150.12h-30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404-error.8b4abb11c7cd3462dd54428defece6d4.svg";
export { ForwardRef as ReactComponent };